export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-background-100 border-t border-background-300/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-950 text-base"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 font-heading">
                蚂蚁影视
              </span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed">
              蚂蚁影视是领先的高清免费在线观影平台，提供最新热播电影电视剧大全。支持1080P/4K超清画质，智能加速不缓冲，全终端无缝切换，随时随地免费畅享精彩影视内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">精选卡片</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a>
              <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">精彩视频</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">服务支持</h4>
            <div className="flex flex-col gap-2">
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#app" onClick={(e) => handleNavClick(e, '#app')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">APP下载</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              蚂蚁影视与国内外多家优质内容制作方、版权方建立了深度合作关系，持续为用户提供更多优质影视资源。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <span className="px-2.5 py-1 bg-background-200/50 rounded-md text-[10px] text-foreground-600">内容合作伙伴招募中</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2023-2026 蚂蚁影视 mayivideo.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-600 cursor-pointer hover:text-foreground-400 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-600 cursor-pointer hover:text-foreground-400 transition-colors">用户协议</span>
            <span className="text-xs text-foreground-600 cursor-pointer hover:text-foreground-400 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}